import { RecruitingPortalType } from "./enums/RecruitingPortalType";

/**
 * Staffing portals ("Bemanningsportal", `RecruitingPortalType` on the organisation) whose
 * bookings are won in the portal and reach the CRM through the ERP import, so a booking
 * for one of their customers must not be created by hand in the CRM.
 *
 * Bemlo since CRMDEV-7351, Medlo since ERP-1489. Add a portal here and both the server guard
 * (`StaffingPortalBookingGuard`) and the booking form pick it up; nothing else needs to know
 * the list. The `blockBookingCreationForBemloCustomers` config key switches the whole block
 * on and off — it keeps its historical name because it is seeded in every environment.
 */
export const BOOKING_CREATION_BLOCKED_RECRUITING_PORTALS: readonly RecruitingPortalType[] =
  [RecruitingPortalType.Bemlo, RecruitingPortalType.Medlo];

/**
 * The blocked portal the given staffing portal is, or `null` when bookings for it may be
 * created in the CRM. Takes a plain string so the web can pass its generated GraphQL enum.
 */
export function bookingCreationBlockedRecruitingPortal(
  recruitingPortalType: string | null | undefined
): RecruitingPortalType | null {
  const portal = BOOKING_CREATION_BLOCKED_RECRUITING_PORTALS.find(
    (blocked) => blocked === recruitingPortalType
  );

  return portal ?? null;
}
